import React, { FC, useCallback, useEffect } from 'react';
import { LayoutWrapper } from 'components/LayoutWrapper';
import { NavigationButton } from 'components/NavigationButton';
import { useNavigate, useLocation } from 'react-router-dom';
import { ActionNotification } from './components/ActionNotification';
import { StatusView } from './components/StatusView';
import { selectConsentStatus, selectUserHID } from './consentSelectors';
import { updateConsentFromLink } from './consentSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { css } from '@compiled/react';
import { PageWrapper } from '../../components/PageWrapper';
import Spinner from '@atlaskit/spinner';
import { createSelectRequestPendingSelector } from '../App';
import { CONSENT_UPDATE_CONSENT_FROM_LINK_PREFIX } from './constants';

const styles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

const Consent: FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(updateConsentFromLink(location.search));
  }, [dispatch, location]);

  const isPending = useAppSelector(createSelectRequestPendingSelector([CONSENT_UPDATE_CONSENT_FROM_LINK_PREFIX]));
  const status = useAppSelector(selectConsentStatus);
  const hid = useAppSelector(selectUserHID);

  const navigationClickHandler = useCallback(() => navigate(`/?hid=${hid}`), [navigate, hid]);

  return (
    <LayoutWrapper>
      <StatusView />
      <PageWrapper>
        <div css={styles}>
          {isPending ? (
            <Spinner size='large' label='Loading' testId='loading-spinner' />
          ) : (
            <>
              <ActionNotification />
              <NavigationButton
                appearance={'primary'}
                isVisible={status.status === 'ok' && hid != null}
                onClick={navigationClickHandler}
              />
            </>
          )}
        </div>
      </PageWrapper>
    </LayoutWrapper>
  );
};

export default Consent;
